import React, { Component } from "react";
import { Button, Form, Image, Row } from "react-bootstrap";
import configData from "../config.json";
import { toast } from "react-toastify";
import Aadhaar from "./Aadhaar.png";
import mobile from "./mobile.png";
import "./Abha.css";
export default class Abhaaddressverfication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requestId: sessionStorage.getItem("requestId"),
      abhaAddress: sessionStorage.getItem("abhaAddress"),
      abhaotp: ["", "", "", "", "", ""],
      abhaaddressotp: ["", "", "", "", "", ""],
      AbhaProfile: {},

      mobile: "",
      showOtp: false,
      showAbha: false,
      showAbhaAddress: false,
      showAddessotp: false,
      cabhaaddress: "",
      custshowAddess: false,
      isAbhaVerifiedReady: false,
      authMethods: "",
      resendTimer: 60, // 10 minutes
      resendEnabled: false,
      resendIntervalId: null,

      // ["aadhaarotp", "mobileotp"]
    };
  }

  formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };
  startResendCountdown = () => {
    this.setState({
      resendEnabled: false,
      resendOtpABAVeCount:
        parseInt(sessionStorage.getItem("resendOtpABAVeCount")) || 0,
      resendTimer: 60,
    });
    const intervalId = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.resendTimer <= 1) {
          clearInterval(this.state.resendIntervalId);
          return { resendEnabled: true, resendTimer: 0 };
        }
        return { resendTimer: prevState.resendTimer - 1 };
      });
    }, 1000);
    this.setState({ resendIntervalId: intervalId });
  };
  // startResendTimer = () => {
  //   this.setState({ resendTimer: 60, resendEnabled: false });

  //   this.resendInterval = setInterval(() => {
  //     this.setState((prevState) => {
  //       if (prevState.resendTimer <= 1) {
  //         clearInterval(this.resendInterval);
  //         return { resendTimer: 0, resendEnabled: true };
  //       }
  //       return { resendTimer: prevState.resendTimer - 1 };
  //     });
  //   }, 1000);
  // };
  ResendOTP = (e) => {
    e.preventDefault();
    let resendCount =
      parseInt(sessionStorage.getItem("resendOtpABAVeCount")) || 0;
    if (resendCount >= 2) {
      this.showToast("Maximum resend attempts reached.", "error");
      return;
    }
    const formData = new FormData();
    formData.append("requestId", this.state.requestId);

    fetch(configData.api_url + "C_Abhadetails/resendAbhaAddressOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          resendCount++;
          sessionStorage.setItem("resendOtpABAVeCount", resendCount + 1);
          clearInterval(this.state.resendIntervalId);
        }
      });
  };
  componentDidMount() {
    this.ResponseHandler();
    if (!sessionStorage.getItem("resendOtpABAVeCount")) {
      sessionStorage.setItem("resendOtpABAVeCount", "0");
    }
    this.startResendCountdown();
    // this.startResendTimer();
  }
  ResponseHandler = () => {
    var formData = new FormData();

    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriverequestId", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success" && data.detail) {
          const abhaDetails = JSON.parse(data.detail.abhaprofile);
          const abhaProfile = abhaDetails.ABHAProfile;
          if (abhaProfile)
            this.setState({
              AbhaProfile: abhaProfile,
            });
        }
      });
  };
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };
  handleImageClick = (option) => {
    this.setState({ authMethods: option });
  };

  handleabhaaddressotpChange = (e, index) => {
    const val = e.target.value;
    if (/^\d?$/.test(val)) {
      this.setState(
        (prevState) => {
          const newOtp = [...prevState.abhaaddressotp];
          newOtp[index] = val;
          return { abhaaddressotp: newOtp };
        },
        () => {
          // auto focus next input if a digit was entered
          if (val && index < 5) {
            this[`otpInput1${index + 1}`].focus();
          }
        }
      );
    }
  };

  handleABHAAddressSearchNext = (e) => {
    e.preventDefault();
    const { abhaAddress, authMethods } = this.state;
    if (!authMethods) {
      this.showToast("Please select Aadhaar or Mobile OTP option.", "error");
      return;
    }
    sessionStorage.setItem("abhaAddress", abhaAddress);
    const formData = new FormData();
    formData.append("abhaAddress", abhaAddress);
    formData.append("authMethods", authMethods);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/getAuthMethodsByabhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.showToast(data.message, data.success);
          sessionStorage.setItem("message", data.message);
          sessionStorage.setItem("resendOtpABAVeCount", "");
          this.setState({ isAbhaVerifiedReady: true }); // changed from data.details.message
        } else {
          this.showToast(data.message || "Something went wrong", "error");

          this.setState({
            resendOtpABAVeCount: "",
          });
        }
      });
  };
  handleABHAAddressSubmitNext = (e) => {
    e.preventDefault();
    const { abhaAddress, authMethods } = this.state;

    sessionStorage.setItem("abhaAddress", abhaAddress);
    const formData = new FormData();
    formData.append("abhaAddress", abhaAddress);
    formData.append("authMethods", authMethods);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/submitAbhaAddress", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
          sessionStorage.setItem("message", data.message); // changed from data.details.message
        } else {
          this.setState({
            responseMessage: data.details.message,
            message: data.message,
            showMessage: true,
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        this.setState({
          responseMessage: "API Error occurred",
          showMessage: true,
        });
      });
  };

  handleSubmitAddressOTPNext = (e) => {
    e.preventDefault();
    const abhaaddressotp = this.state.abhaaddressotp.join("");

    sessionStorage.setItem("abhaotp", this.state.abhaaddressotp);
    var formData = new FormData();

    formData.append("abhaaddressotp", abhaaddressotp);
    formData.append("requestId", sessionStorage.getItem("requestId"));

    fetch(configData.api_url + "C_Abhadetails/submitAbhaAddressOtp", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.success);
        if (data.status === "success") {
        }
      });
  };

  onKeyDownONE = (e, idx) => {
    if (e.key === "Backspace" && !this.state.abhaaddressotp[idx] && idx > 0) {
      this[`otpInput1${idx - 1}`].focus();
    }
  };
  handleabhaaddressChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ abhaAddress: fieldValue });
  };

  HandleClick = () => {
    this.setState({ isSubmitting: true });
    var formData = new FormData();
    formData.append("requestId", this.state.requestId);
    fetch(configData.api_url + "C_Abhadetails/retriveAbhacard", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message);
        if (data.status === "success") {
        }
        this.setState({
          isSubmitting: false,
        });
      });
  };

  HandleNextSubmit = () => {
    window.location.href = "/abhaprofile";
  };
  HandleNewClick = () => {
    const { abhaAddress, aadharNumber, abhanumber } = this.state;
    sessionStorage.setItem("abhaAddress", abhaAddress);
    sessionStorage.setItem("aadharNumber", aadharNumber);
    sessionStorage.setItem("abhanumber", abhanumber);

    window.location.href = "/abhaverification";
  };
  handlenextClick = () => {
    const { abhanumber, aadharNumber } = this.state;
    sessionStorage.setItem("abhaAddress", this.state.AbhaProfile.phrAddress);
    sessionStorage.setItem("aadharNumber", aadharNumber);
    sessionStorage.setItem("abhanumber", abhanumber);

    window.location.href = "/abhaprofile ";
  };

  render() {
    const {
      abhaaddressotp,
      showAbhaAddress,
      showAddessotp,
      abhaAddress,
      authMethods,
      resendEnabled,
      resendTimer,
    } = this.state;
    return (
      <div>
        <div className="row mb-2" id="flowStyle">
          <div className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-collection nav-icon">
              <p className="nav-label mt-2">Consent Collection</p>
            </div>
          </div>

          <div className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-file-richtext nav-icon">
              <p className="nav-label mt-2">Mobile Authentication</p>
            </div>
          </div>
          <div className="col-md-3 active-page">
            <div className="widget_BG widget_BG_grid bi bi-file-person nav-icon">
              <p className="nav-label mt-2">ABHA Verfication</p>
            </div>
          </div>
          <div className="col-md-3 Inactive">
            <div className="widget_BG widget_BG_grid bi bi-info-square nav-icon">
              <p className="nav-label mt-2">Profile Collection</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-md-center text-center">
          <div className="col-md-6">
            <div className="widget_BG widget_BG_grid mb-2">
              <Form.Group>
                <Form.Label>ABHA Address</Form.Label>
                <div className="d-flex gap-2">
                  <Form.Control
                    type={showAbhaAddress ? "text" : "password"}
                    value={abhaAddress}
                    onChange={this.handleabhaaddressChange}
                    className="form-control"
                    onKeyDown={this.onKeyDown}
                  />

                  <Button
                    variant="outline-secondary"
                    className={`rounded-0 bi ${
                      showAbhaAddress ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={() =>
                      this.setState({ showAbhaAddress: !showAbhaAddress })
                    }
                  />
                </div>

                <div className="row justify-content-md-center">
                  <p>Validate using</p>

                  <div className="col text-center">
                    <div
                      onClick={() => this.handleImageClick("aadhaarotp")}
                      style={{
                        border:
                          authMethods === "aadhaarotp"
                            ? "2px solid blue"
                            : "1px solid #ccc",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      <Image
                        src={Aadhaar}
                        className="navbar-brand pe-3 ps-4 ps-lg-2"
                        alt="Aadhaar"
                        style={{
                          // width: "",
                          height: "44px",
                          marginBottom: "5px",
                        }}
                      />
                      <Form.Check
                        label="Aadhaar OTP"
                        name="otpMethod"
                        type="radio"
                        disabled
                        checked={authMethods === "aadhaarotp"}
                      />
                    </div>
                  </div>

                  <div className="col text-center">
                    <div
                      onClick={() => this.handleImageClick("mobileotp")}
                      style={{
                        border:
                          authMethods === "mobileotp"
                            ? "2px solid blue"
                            : "1px solid #ccc",
                        padding: "10px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                    >
                      <Image
                        src={mobile}
                        className="navbar-brand pe-3 ps-4 ps-lg-2"
                        alt="Mobile"
                        style={{
                          width: "auto",
                          height: "44px",
                          marginBottom: "5px",
                        }}
                      />
                      <Form.Check
                        label="Mobile OTP"
                        name="otpMethod"
                        type="radio"
                        disabled
                        checked={authMethods === "mobileotp"}
                      />
                    </div>
                  </div>
                </div>
                {/* <Button
                  className="rounded-0 m-1"
                  onClick={this.handleABHAAddressSearchNext}
                >
                  ABHA Search
                </Button> */}

                <Button
                  //   disabled={!this.state.isAbhaVerifiedReady}
                  className="rounded-0 m-1"
                  onClick={this.handleABHAAddressSubmitNext}
                >
                  Verify ABHA Address
                </Button>
              </Form.Group>
              {this.state.showMessage && (
                <i style={{ color: "blue" }}>{this.state.message}</i>
              )}
              <Form.Group className="abhaaddressverificationOTP">
                <Form.Label>Enter OTP</Form.Label>
                <div className="d-flex gap-2">
                  {abhaaddressotp.map((digit, idx) => (
                    <Form.Control
                      key={idx}
                      type={this.state.showAddessotp ? "text" : "password"}
                      name="abhaaddressotp"
                      id="abhaaddressotp"
                      maxLength={1}
                      onKeyDown={(e) => this.onKeyDownONE(e, idx)}
                      value={digit}
                      ref={(input) => (this[`otpInput1${idx}`] = input)}
                      className="form-control"
                      onChange={(e) => this.handleabhaaddressotpChange(e, idx)}
                    />
                  ))}

                  <Button
                    variant="outline-secondary"
                    className={`rounded-0 bi ${
                      this.state.showOtp ? "bi-eye-slash" : "bi-eye"
                    }`}
                    onClick={() =>
                      this.setState({ showAddessotp: !showAddessotp })
                    }
                  />
                </div>
                <div as={Row}>
                  <div className="col">
                    {parseInt(sessionStorage.getItem("resendOtpABAVeCount")) >=
                    2 ? (
                      <></>
                    ) : (
                      <Button
                        className="rounded-0 m-1"
                        variant="warning"
                        onClick={this.ResendOTP}
                        disabled={!resendEnabled}
                      >
                        Resend OTP{" "}
                        {!resendEnabled && `in ${this.formatTime(resendTimer)}`}
                      </Button>
                    )}
                  </div>
                  <div className="col">
                    <Button
                      className="rounded-0 m-1"
                      disabled={
                        abhaaddressotp.some((d) => d === "") ||
                        abhaaddressotp.length !== 6
                      }
                      onClick={this.handleSubmitAddressOTPNext}
                    >
                      {this.state.isSubmitting
                        ? "Submitting..."
                        : "Verify\u00A0ABHA\u00A0OTP"}
                    </Button>
                  </div>
                </div>
              </Form.Group>
            </div>
          </div>
        </div>
        <div className="row  widget_BG widget_BG_grid m-0 mt-2">
          <div className="col text-end">
            <Button className="rounded-0 m-1" onClick={this.HandleNewClick}>
              Back
            </Button>
            <Button className="rounded-0 m-1" onClick={this.handlenextClick}>
              Next{" "}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
